export default {
  commonTxt: {
    nodata: "No data",
    loading: "Loading",
    more: "More"
  },
  main: {
    logo: "Clinical trial volunteer\nrecruitment site",
    slide: {
      title: "Most popular study",
      detail: "View Details"
    },
    closing: {
      title: "Close to recruiting",
      txt: "days to the deadline"
    },
    research: {
      tabTitle1: "Study on Healthy Volunteer application of Healthy Volunteers",
      tabTitle2: "A Study on the application of Disease Volunteers"
    },
    counter: {
      count1: "The number of volunteers who have applied this year",
      count2: "Total number of studies carried out this year",
      count3: "Number of ongoing studies",
      persons: "people",
      case: "recruitments"
    },
    banner: {
      txt1:
        "If you add Kakao Talk Plus friend,\nIt's easy and fast to get counseling on 1:1.",
      txt2:
        "Plus Friend the Center for Clinical Trial at Seoul National University",
      txt3: "+ How to add kakao plus friend"
    }
  },
  login: {
    placeholderId: "E-mail (ID) Input",
    placeholderPw: "Input password",
    buttonTxt: "Login",
    user: "님",
    logout: "Log out",
    mypage: "My Page",
    saveId: "Save ID",
    signIn: "Join Membership",
    findId: "Find my ID",
    findPw: "Find Password"
  },
  join: {
    title: "Join Membership",
    titleStep1: "Write personal Information",
    titleStep2: "Writing a clinical trial application form",
    password: "Password",
    confirmPw: "Check Password",
    duplicate: "※ Already subscribed email. Please check.",
    always: "Application (any time)",
    alwaysTxt:
      "* In case you apply to this category, the person in charge can contact you any time to confirm your availbility to apply.",
    btnJoin: "Sign up as a member",
    btnCancel: "Cancel",
    alertCancel: "Do you want to cancel join?",
    failJoin: "Failed to join",
    completeTit: "Sign up as a member has been completed!",
    completeTxt1: "회원님의 이메일(ID)는",
    completeTxt2: "입니다.",
    completeTxt3:
      "Please check and apply for your volunteer work and the appropriate recruitment.",
    completeBtn: "Getting Started"
  },
  findAccount: {
    titleId: "Find ID",
    titlePw: "Find Password",
    titleChangePw: "Change Password",
    mail: "E-mail (ID)",
    placeholderMail: "Please enter your e-mail (ID).",
    name: "full name",
    placeholderName: "Please enter full name",
    gender: "Sex",
    rdoMale: "Male",
    rdoFemale: "Female",
    birth: "the date of birth",
    phone: "cell phone number",
    placeholderPh: "please input your cell phone number",
    newPw: "New Password",
    confirmPw: "Check Password",
    btnTxtId: "Find my ID",
    btnTxtPw: "Find Password",
    btnTxtLogin: "Login",
    btnTxtHome: "move to main",
    btnTxtChange: "Change Password",
    btnTxtCancel: "Cancel",
    idResultTitle: "Search Result",
    idResult:
      "This IDs have been inquired with your inputs. Some of fields will be marked as * to protect your personal information.",
    errorId: "No ID was found",
    errorMail:
      "※ Email(ID) or password is not correct, please check you emial or password.",
    withdrawMail: "※ Unsubscribed email",
    alertPw: "Password change is complete.",
    errorPw: "Password change failed.",
    errPwConfirm: "※ You can only set more than 9 combinations of uppercase and lowercase letters + numbers + special characters.",
    wrongCnt: "Login blocked because you have exceeded the number of allowable login attempts. Please inquire at Kakao Talk Plus Friend Seoul National University Hospital Clinical Trial Center or 02-741-4221."
  },
  footer: {
    addr:
      "Seoul National University Hospital Clinical Trials Center | 101 Daehak-ro,Jongno-gu, Seoul 110-744, South Korea",
    familySite: "Family Site",
    family: [
      {
        id: 0,
        href: "https://www.snu.ac.kr/",
        txt: "Seoul National University"
      },
      {
        id: 1,
        href: "http://medicine.snu.ac.kr/",
        txt: "Seoul National University School of Medicine "
      },
      // {
      //   id: 2,
      //   href: "http://clinpharm.snu.ac.kr/",
      //   txt: "Seoul National University"
      // },
      // {
      //   id: 3,
      //   href: "http://www.snu.ac.kr/index.html",
      //   txt:
      //     "Seoul National University Graduate School Collaboration Course and Clinical Pharmacology major page"
      // },
      {
        id: 2,
        href: "http://www.snuh.org/intro.do",
        txt: "Seoul National University Hospital"
      },
      {
        id: 3,
        href: "http://ctc.snuh.org/",
        txt:
          "Seoul National University Hospital Medical Life Research Institute"
      },
      {
        id: 4,
        href: "https://hrpp.snuh.org/pub/_/singlecont/view.do",
        txt:
          "Seoul National University Hospital Clinical Research Ethics Center (HRPP)"
      }
    ]
  },
  navigation: [
    {
      name: "Clinical Trials Center",
      children: [
        "About the Center",
        "Meaning of\nParticipating clinical Trials",
        "Participating Process",
        "Screening Inspection and\n Inpatient Guidance",
        "Guide you to the\n Seoul National University Hospital App"
      ]
    },
    {
      name: "Research\ninformation",
      children: ["Clinical trial recruitment information"]
    },
    {
      name: "Contact Us",
      children: ["FAQs", "Contact Us"]
    },
    {
      name: "My application\ninformation",
      children: [
        "Member information",
        "Clinical trial application",
        "application History",
        "QnA"
      ]
    }
  ],
  infomation: {
    txt: "SNUH CTC Subject Recruitment Team: ",
    contact: "82+2+741+4221 ",
    time: "(Weekdays, 9am-6pm)"
  },
  about: {
    indroduce: {
      title: "About SNUH CTC",
      Paragraph1:
        "Seoul National University Hospital Clinical Trials had established on 1995 to promote advancement of clinical trials quality by providing best research environment allowing scientific and ethical clinical trials based on international standards, such as ICH, FDA guideline and KGCP. On 2004, the center was designated as the nation's 1st regional clinical trials center and the nation's 1st Global Center of Excellence in Early Clinical Trials (GREATS)",
      Paragraph2:
        "SNUH CTC is professionally operated according to its space and facilities that are equipped for various sectors such as oncology, pediatric, medical devices department. We also provides administrative support, basic researchers and facilities to carry out studies like bioequivalence testing, efficacy and safety evaluation of drugs-including new medication-and medical devices. Not only investigators of SNUH CTC, but also personnel with the right qualifications and conditions for the academic-industrial collaborative research can take advantage of SNUH CTC",
      Paragraph3:
        "Seoul National University Hospital Clinical Trials Center is accredited by AAHRPP, WHO FERCAP. These accreditation showes that the safety and the rights protection of research subjects is continuously maintained based on international standards. The active participation is recommanded to many individuals to ethical and scientific trials performed at SNUH CTC",
      Paragraph4: "Please visit SNUH CTC website to see more details",
      link: "http://ctc.snuh.org/"
    },
    meaning: {
      title: "Definition of volunteering Clinical Trials",
      Paragraph1:
        "Have you thought that you can help to develop the pharmaceutical products for diabetes, Alzheimer’s disease or atopic dermatitis? Seoul National University Hospital Clinical Trials Center is conducting the clinical trials with pharmaceuticals companies which are actively conducting the research in areas of pharmaceutical products for the clinical trials, medicine manufacture and biotechnology as partners in order to treat various diseases. Participation in the Seoul National University Hospital Clinical Trials Center’s research has the following meanings.",
      Paragraph2: "Please apply online or contact us via phone call.",
      list: [
        {
          id: 1,
          txt:
            "It is worthwhile to help to develop the treatments of patients suffering from chronic or severe diseases."
        },
        {
          id: 2,
          txt:
            "You can contribute to improve the society’s negative perception of the clinical trials."
        },
        {
          id: 3,
          txt:
            "You can get a comprehensive health screening service according to circumstances of test."
        },
        {
          id: 4,
          txt:
            "You will receive compensation as appreciation for faithfully participating in the clinical trial."
        },
        {
          id: 5,
          txt: "You will have the opportunity to make new acquaintances."
        },
        {
          id: 6,
          txt: "You can escape from the daily routine and take a break."
        },
        {
          id: 7,
          txt:
            "Since there are various studies from one day visit to draw the blood to one month hospitalization, you can participate in suitable study that fits your schedule."
        }
      ]
    },
    process: {
      title: "Procedure guidance",
      processData: [
        {
          id: 1,
          title: "Screening by phone call",
          imgName: "process_phone",
          cont: `When you apply to be a volunteer for the clinical trials through the homepage or phone call, you will talk to the volunteer call center. The volunteer call center is available from 9:00 am to 6:00 pm on Monday through Friday. Personnel in charge of phone call screening will tell you whether you are basically qualified for the study, and ask questions about medical history including medication. We will request for you to answer them honestly. It is an essential factor for you to participate in the clinical trial safely.`
        },
        {
          id: 2,
          title: "Appointments for screening",
          imgName: "process_appointment",
          cont:
            "If you conclude the phone call screening, you will make a screening appointment. Prior to the screening, you are usually asked to be fasting for 10 hours or more. You need to visit the center on time with your ID card. If you cannot visit at the appointed time, you may get disadvantage to get the opportunity to participate in the futhur study. Thus, you should contact us to cancel the appointment at least a day ahead of it.\n\nPrior to screening, general information which you must be well informed is as follows:\n\n- Enough rest and sleep We tend to recommand to have enough sleep before the day of screening, in order to prevent extra visit for screening, since it is likely to be eliminated easily if you did not."
        },
        {
          id: 3,
          title: "Signing the informed consent form",
          imgName: "process_agree",
          cont:
            "We will let you read the informed consent form before the screening is performed. The consent form includes very detailed information about the entire study. This document includes the purpose of study, dosage of drug, frequency and amount of drawing blood, adverse effects reported in relation to this drug and all procedures to be conducted in this study. It is very important to read the entire consent form in order to understand your role and potential risks in this study. Staffs will describe the study and answer the questions that you may have. We will ask you to sign the consent form in order to indicate that you read and understand this consent form."
        },
        {
          id: 4,
          title: "Screening process",
          imgName: "process_screening",
          cont:
            "Once you sign the informed consent form for the clinical trial, the next steps may vary in each study. In general, height, weight and vital signs (body temperature, blood pressure and pulse) are measured in the screening room. In the outpatient clinic, blood test, ECG test and urine test are conducted. After all tests are finished, you are back to the screening room and a physical exam is performed. After you are given the information which you should be well informed in relation to the hospitalization or outpatient visit, you can go back to your personal daily routine. Time for screening process may vary in each study. However it usually takes about 2 – 3 hours to describe information related to the study and sign the consent form."
        },
        {
          id: 5,
          title: "Selected as volunteers",
          imgName: "process_vounteer",
          cont:
            "After the screening is finished, a researcher reviews the results of various tests conducted in the screening. We will let you know whether you can participate in the study over the phone."
        },
        {
          id: 6,
          title: "Hospitalization",
          imgName: "process_hospital",
          cont:
            "Even though the condition for hospitalization may vary in each study, you are usually hospitalized in the research ward which is located on the 3rd floor in the Seoul National University Hospital Biomedical Research Institute. Patient rooms can be used for 4 – 6 people with the same gender. After you arrive at the ward, the general guidance for hospitalization life is given. Once you go to the designated room and bed, you change into a patient gown. The bathroom in the research ward is equipped with shampoo, soap, toothpaste and body lotion. Since the common washing machine is in the laundry room, you can wash clothes with detergent. During hospitalization, you can store personal belongings in the locker. In addition, going outside, sleeping out, acquaintances visiting and eating snacks are prohibited."
        },
        {
          id: 7,
          title: "First day",
          imgName: "process_day1",
          cont:
            "Even though it may vary depends on the protocol of the study on the first day, most things will be performed on the first day. Since all research procedures are conducted on designated time, the most of the research members will be there to acquire accurate data and keep the schedule at the same time. The approximate schedules for the first day are as follows. You wake up at 7:50 am and a urine test is performed. From 8 am to the lunch time, blood is drawn along vital sign measuring. In addition, you will get physical examination and ECG test. You may eat the meal after 4 hours upon administration of the drug and you may drink water after 2 hours upon administration of the drug."
        },
        {
          id: 8,
          title: "Administration of the drug",
          imgName: "process_medication",
          cont:
            "As mentioned previously, the administration of the drug is given on the first day. Since nothing is more important than your safety, the investigator stays in the ward and continues to monitor your status on the day of administration of the drug. Thus, if you feel any small inconvenience when compared to that before administration of the drug, you will get help quickly from the research personnel."
        },
        {
          id: 9,
          title: "Meal",
          imgName: "process_meal",
          cont:
            "Except the case that requires fasting, you will be provided with a meal during the entire period of hospitalization. Since the type of meal or amount of meal may be assigned in some studies, you may not have meals as much as you desire. In addition, you may have meals only when it is assigned by the study."
        },
        {
          id: 10,
          title: "Activity",
          imgName: "process_acivity",
          cont:
            "The Seoul National University Hospital Clinical Trials Center had been putting many efforts for your convenience. We help you to freely watch a TV by installing a TV in each bed. We provide you the entertainment which you can enjoy free time by playing a video game or a board game. In addition, lounge is equipped with comic books and various books. Since the research ward is equipped with 4 PCs, you can easily access to the internet. If you want to use a personal mobile devices rather than a common PC in the ward, please feel free to bring and use it."
        },
        {
          id: 11,
          title: "Discharge procedure",
          imgName: "process_discharged",
          cont:
            "Once every research procedure is finished during the period of hospitalization, you can be discharged. It is difficult to schedule the discharge time, a volunteer is generally discharged at around 10 am after the breakfast."
        },
        {
          id: 12,
          title: "Additional visits or phone call",
          imgName: "process_phone",
          cont:
            "In some cases, you may need to visit the center again, due to re-examination. In this case, we may ask you to come again via phone call."
        },
        {
          id: 13,
          title: "Compensation",
          imgName: "process_reward",
          cont:
            "We will reward you for your effort and time as possible as it can be. Submit your photo copy of accout, and compensation will be deposited within max 21days from the end of study.\nFriend Referral Program You can recommend clinical trials to friends or acquaintances. If your friends participate to study, Gift or compensation will given. Currently, we apply this program "
        }
      ]
    },
    subjectguide: {
      title: "Screening Inspection and Inpatient Guidance",
      section1: {
        title: "Explanation of clinical trials and visits to screening tests",
        subTitle:
          "Explanation of clinical trials and visits to screening tests",
        list: [
          "the significance of a clinical trial",
          "Pre-visit Verification",
          "Pre-visit precautions",
          "Procedure for participating in clinical trial briefing sessions and screening tests",
          "Precautions for writing consent forms and screening sheets",
          "Limits for participating in clinical trials",
          "Post-inspection progress"
        ]
      },
      section2: {
        title: "During your stay",
        subTitle: "During your stay",
        list: [
          "Inpatient Life Related",
          "Subject person's rules according to research"
        ]
      }
    },
    appguide: {
      title: "Guide you to the Seoul National University Hospital App",
      title2:
        "Guide you to the Seoul National University Hospital mobile application app",
      cont:
        "Seoul National University Hospital has produced a mobile application for Seoul National University Hospital for those who use its homepage on their smartphones.\n In addition to convenient medical treatment within the hospital, it also offers a variety of functions to help you take care of your health outside of the hospital.\n The app also provides care reservation, appointment schedule confirmation, medical staff introduction, and hospital news. You can search and install 'Seoul National University Hospital' in Google Play Store and Apple App Store.",
      appTxt: "iPhone App",
      androidTxt: "Android App",
      downTxt: "[Download]"
    }
  },
  faq: {
    title: "FAQs",
    list: [
      {
        id: 0,
        tabName: "FAQs",
        cont: [
          {
            id: 0,
            tabName: "Volunteering for clinical trials",
            que: "Can “I” participate in the study?",
            ans: "Each clinical trial has different requirements."
          },
          {
            id: 1,
            tabName: "Clinical Trials",
            que: "Can I see ongoing studies?",
            ans:
              "You can get more information, if you enter ‘ongoing study’ or call the volunteer recruitment center."
          },
          {
            id: 2,
            tabName: "Hospitalization",
            que: "Can family members and friends visit me?",
            ans:
              "We do not allow visitors to come to the center in order to acquire the accurate results of the study and ensure the confidentiality of the participants. It is recommended to make a new friend in the ward."
          },
          {
            id: 3,
            tabName: "Volunteering for clinical trials",
            que:
              "What are the risks and benefits of participating in a clinical trial?",
            ans:
              "Potential risks and benefits of clinical trials may vary for each study. Before you sign the informed consent form for the clinical trial, you can hear the explanation of the risks and benefits. In addition, if you have any questions about matters not to be described, you can ask questions to medical staffs."
          },
          {
            id: 4,
            tabName: "Volunteering for clinical trials",
            que: "Who can participate in the study ?",
            ans:
              "In general, people at the age of 19 or more can participates in the clinical trials being carried out in the center. However, medical requirements may vary on each study. Only healthy volunteers determined by the research proposal can participate in the phase 1 clinical trial. Prerequisite standard may include smoking, particular pharmaceutical products, drug use and alcohol. Those who have certain medical conditions and requirements as an eligibility similar to those for the phase 1 can participate in phase 2 or phase 3 clinical trials."
          },
          {
            id: 5,
            tabName: "Clinical Trials",
            que: "What is the clinical trial ?",
            ans:
              "“Clinical trial” is referred to as the test or study to be conducted with human subjects in order to examine the pharmacokinetics and pharmacodynamics of drugs, the medical and clinical effects of drugs. Clinical trial is the process to verify the efficaciousness and adverse reaction with the purpose to demonstrate the safety and efficacy of investigational pharmaceutical products. As the clinical trial is the academic activity to be conducted to ascertain the matters which have not yet been evaluated, it is different from common methods for prevention, diagnosis and treatments.\nOnce the pharmaceutical products, medical device and medical technology are validated compeletly, the result of its clinical trial can be a standard method."
          },
          {
            id: 6,
            tabName: "Volunteering for clinical trials",
            que:
              "Can I withdraw from the study after volunteering in the clinical trial ?",
            ans:
              "Yes, you can.\nSince the subjects should voluntarily participate in the clinical trial, you are free to withdraw at any time such as after volunteering, after physical examination (screening) or even during the clinical trial.\nWithdrawal does not cause any disadvantage.\nHowever, if you withdraw from it during the clinical trial, a doctor may ask you a re-visit for a checkup."
          },
          {
            id: 7,
            tabName: "Clinical Trials",
            que: "Is my information kept confidential ?",
            ans:
              "Personal information will be protected by employees of the Seoul National University Hospital as long as it is not required by law to present. Your medical information will not be provided. Related regulatory authorities and sponsors for the clinical trial or KFDA may see the personal information such as the name and address in order to check the medical records for one’s identification. If necessary, it can be duplicated during the test period.\nThus, the personal information cannot be protected absolutely due to the need for the use of personal information."
          }
        ]
      },
      {
        id: 1,
        tabName: "Clinical Trials",
        cont: [
          {
            id: 0,
            que: "Can I see ongoing studies?",
            ans:
              "You can get more information, if you enter ‘ongoing study’ or call the volunteer recruitment center."
          },
          {
            id: 1,
            que: "What is the clinical trial ?",
            ans:
              "“Clinical trial” is referred to as the test or study to be conducted with human subjects in order to examine the pharmacokinetics and pharmacodynamics of drugs, the medical and clinical effects of drugs.\nClinical trial is the process to verify the efficaciousness and adverse reaction with the purpose to demonstrate the safety and efficacy of investigational pharmaceutical products. As the clinical trial is the academic activity to be conducted to ascertain the matters which have not yet been evaluated, it is different from common methods for prevention, diagnosis and treatments.\nOnce the pharmaceutical products, medical device and medical technology are validated compeletly, the result of its clinical trial can be a standard method."
          },
          {
            id: 2,
            que: "Is there any risk about participating in a clinical trial?",
            ans:
              "Risks for each clinical trial may vary.\nHowever, Institutional Review Board (IRB) examines whether each clinical trials’ design has own appropriate provision for potential risk that might occur before they give approbation. Therefore, the risks of the clinical trial can be minimized in the stage of planning. Of course, researchers will continue to manage the risks in the course of conducting the clinical trial."
          },
          {
            id: 3,
            que:
              "If I participate in a clinical trial, will I take the drug which is being developed ?",
            ans:
              "During clinical trials, you may take drugs which had already been developed or placebos (substance with no effects).\nTherefore, if you are assigned to a control group taking developed drugs* or placebos, you may not take drugs which are on the developing process. (*developed drug: Drug that is already on the market or drug that had completed total clinical trials from phase1 to phase4)"
          },
          {
            id: 4,
            que: "How is the new drug approved ?",
            ans:
              "It must go through extensive tests and approval processes.\n First, a pharmaceutical product goes through a strict preclinical testing process.\n Once the next stage is approved by regulatory authorities, the safety test for humans will be done through a clinical trial.\n If it is approved by regulatory authorities, the safety and efficacy of the drug for clinical trials are tested with patients with disabilities. Then, a sponsor submits a report showing approval/ rejection of the drug or requirements of the additional test to the regulatory authorities."
          },
          {
            id: 5,
            que:
              "Can I withdraw from the study after volunteering in the clinical trial ?",
            ans:
              "Yes, you can.\n Since the subjects should voluntarily participate in the clinical trial, you are free to withdraw at any time such as after volunteering, after physical examination (screening) or even during the clinical trial.\n Withdrawal does not cause any disadvantage.\n However, if you withdraw from it during the clinical trial, a doctor may ask you a re-visit for a checkup."
          },
          {
            id: 6,
            que:
              "How can the rights and welfare of the subjects who participates in the clinical trial will be protected?",
            ans:
              "It is carried out by qualified medical personnel.\n In addition, there are rules to protect the participants in the clinical trial and the standards for the protocol to perform the clinical trials. For example, after Institutional Review Board (IRB) reviews the research proposal and related materials, it allows the research to be conducted scientifically and ethically.\n IRB supervises the processes of giving the participants the information including the purpose of the study, process of conducting the study, related risks and results of previous study."
          },
          {
            id: 7,
            que: "Is my information kept confidential ?",
            ans:
              "Personal information will be protected by employees of the Seoul National University Hospital as long as it is not required by law to present. Your medical information will not be provided. Related regulatory authorities and sponsors for the clinical trial or KFDA may see the personal information such as the name and address in order to check the medical records for one’s identification. If necessary, it can be duplicated during the test period.\n Thus, the personal information cannot be protected absolutely due to the need for the use of personal information."
          }
        ]
      },
      {
        id: 2,
        tabName: "Compensation",
        cont: [
          {
            id: 0,
            que: "Is compensation given ?",
            ans:
              "Yes. You can receive compensation for your time and effort you’ve spent for the study.\n Amount of compensation may vary based on the period and the type of the study.\n You can find the detailed information on compensation in the current on-going study."
          },
          {
            id: 1,
            que: "How can I get compensation ?",
            ans:
              "It will be deposited into your bank account within three weeks once the study is finished."
          }
        ]
      },
      {
        id: 3,
        tabName: "Volunteering for clinical trials",
        cont: [
          {
            id: 0,
            que: "Can “I” participate in the study?",
            ans: "Each clinical trial has different requirements."
          },
          {
            id: 1,
            que:
              "What are the risks and benefits of participating in a clinical trial?",
            ans:
              "Potential risks and benefits of clinical trials may vary for each study.\n Before you sign the informed consent form for the clinical trial, you can hear the explanation of the risks and benefits.\n In addition, if you have any questions about matters not to be described, you can ask questions to medical staffs."
          },
          {
            id: 2,
            que: "Can women participate in the study ?",
            ans:
              "Yes. Men and women at all ages can be a volunteer.\n In fact, we need female volunteers including postmenopausal women."
          },
          {
            id: 3,
            que:
              "Can I withdraw from the study after volunteering in the clinical trial?",
            ans:
              "Yes, you can.\n Since the subjects should voluntarily participate in the clinical trial, you are free to withdraw at any time such as after volunteering, after physical examination (screening) or even during the clinical trial.\n Withdrawal does not cause any disadvantage. However, if you withdraw from it during the clinical trial, a doctor may ask you a re-visit for a checkup."
          },
          {
            id: 4,
            que:
              "Can subjects participate in more than one study at the same time ?",
            ans:
              "No. volunteers should take a break period of 1 ~ 3 months between the last clinical trial and new clinical trial."
          },
          {
            id: 5,
            que: "How often can I participate in the clinical trial ?",
            ans:
              "Volunteers should take a break period of 1 ~ 3 months between the last clinical trial and new clinical trial.\n After that, you are free to participate in other clinical trials."
          },
          {
            id: 6,
            que: "What are the obligations of the volunteers ?",
            ans:
              "There are certain rules and conditions depending on the types of studies in order to acquire accurate test results.\n For example, it may include the restrictions on exercise, smoking, taking a drug and drinking alcohol.\n We will provide you with detailed information on these obligations before you participate in the study. "
          },
          {
            id: 7,
            que: "Where can I find the clinical trials which are on the plan?",
            ans:
              "If you click on ‘ongoing studies’, you can see more information about the study.\n It provides you detailed information such as the title of clinical trial, date, compensation and types of volunteers to be recruited."
          },
          {
            id: 8,
            que: "Who can participate in the study ?",
            ans:
              "In general, people at the age of 19 or more can participates in the clinical trials being carried out in the center.\n However, medical requirements may vary on each study. Only healthy volunteers determined by the research proposal can participate in the phase 1 clinical trial. Prerequisite standard may include smoking, particular pharmaceutical products, drug use and alcohol. Those who have certain medical conditions and requirements as an eligibility similar to those for the phase 1 can participate in phase 2 or phase 3 clinical trials."
          },
          {
            id: 9,
            que: "How is the research conducted ?",
            ans:
              "If you participate in the phase 1 clinical trial, you are usually hospitalized in the research ward for a day or more.\n Or you need to visit the outpatient clinic several times. Otherwise, you may need to take drugs at home.\n The number of hospitalization days and outpatient visits depends on the condition of each study.\n While you are hospitalized, the research team may draw blood, perform certain procedure to obtain physical status and measure vital signs several times.\n While the test is carried out, you can read a book, study, watch a TV, play a video game, board game and with computers."
          },
          {
            id: 10,
            que:
              "Can I participate in the clinical trial while I am taking personal medicine?",
            ans:
              "It depends on the conditions of the clinical trials in which you are participating.\n In most cases of clinical trials with healthy volunteers, it may be impossible for those who are taking medicine to participate in the study. If those who receive the treatments for a short term, they can participate after the treatment is finished. In some studies with targets of patients, are already designed to allow volunteers to take personal medicine.\n If you have further questions about taking medicine, please contact the volunteer recruitment center"
          }
        ]
      },
      {
        id: 4,
        tabName: "Screening",
        cont: [
          {
            id: 0,
            que: "What are the subjects asked to do for screening process?",
            ans:
              "- Your ID card will be confirmed.\n\n - Medical staffs will explain about the study to you and answer your questions.\n\n - If you agree to participate in the study, you will sign the informed consent form.\n\n - Detailed medical and social (general) information will be collected.\n\n - Blood and urine samples will be collected.\n\n - Blood pressure and pulse may be measured and ECG test may be performed.\n\n - Once the test results deducted, you will be informed of the next step."
          },
          {
            id: 1,
            que: "How long does the screening take ?",
            ans:
              "The time required for the tests varies in each study. You can assume that it will take 2 – 3 hours on average."
          },
          {
            id: 2,
            que:
              "Why do I need to take screening each time I participate in the study?",
            ans:
              "The screening is the process to select volunteers who can participate in the clinical trial.\n Because the clinical trials require relatively less number of volunteers.\n Those who meet the requirements of the study that can provide compatible data well, should participate in the study.\n Doctors should review the test results in order to select volunteers who can participate in each study."
          },
          {
            id: 3,
            que: "What happens if I fail the screening?",
            ans:
              "There are many reasons for failure in the screening.\n If you have any questions about it, we will answer about that matters.\n Therefore, please do not hesitate to ask. In addition, you can ask to the “Volunteer Recruitment Center” whether you can enroll in the next or on-going clinical trial."
          }
        ]
      },
      {
        id: 5,
        tabName: "Hospitalization",
        cont: [
          {
            id: 0,
            que: "Should I be hospitalized?",
            ans:
              "It depends on the study which you are participating.\n Some cases require one time outpatient visit and overnight stay.\n In most cases, you need to be hospitalized for longer period, because the results of clinical trials should be supervised.\n However, you can spend your time freely within the ward."
          },
          {
            id: 1,
            que: "What do I need to bring to the hospital for hospitalization?",
            ans:
              "The bathroom is equipped with a soap, shampoo, toothpaste and blow-dryer.\n Other stuffs such as patient clothes, blanket, towel, slippers, disposable razors, water cup and toothbrush will be provided.\n (*If you are hospitalized twice or more, it will be provided upon the first hospitalization).\n If necessary, you can bring your own belongings including toiletries, books and a laptop etc.\n However, the center is under no liability for any loss or theft of personal property."
          },
          {
            id: 2,
            que: "Can I use my cellular phone and a laptop ?",
            ans:
              "Yes, you can bring them and use. Since the center provides free Wi-Fi."
          },
          {
            id: 3,
            que: "Can you go outside?",
            ans:
              "In most cases, you cannot go out of the ward.\n If you are hospitalized for a long-term, you can go outside with the consent of the medical staffs."
          },
          {
            id: 4,
            que: "Do I have to come on the assigned day?",
            ans:
              "Yes. Since each clinical trial assigns the day for subjects, you must visit the hospital on the assigned day.\n Research design of the clinical trials varies, but it is important to collect data on the assigned day in order to examine the effects of the drug. To do this, you should visit the center on the assigned date and time.\n However, since the schedule for visiting the center can be changed in some cases, you can contact the volunteer recruitment center for further information. "
          },
          {
            id: 5,
            que: "Can family members and friends visit me?",
            ans:
              "We do not allow visitors to come to the center in order to acquire the accurate results of the study and ensure the confidentiality of the participants. It is recommended to make a new friend in the ward. "
          }
        ]
      }
    ]
  },
  recruit: {
    all: "all",
    male: "Male",
    female: "Female",
    koreanAge: "만",
    month: "month",
    currency: "WON",
    age: "years old"
  },
  recruitList: {
    title: "Clinical trial recruitment information",
    alertAge: "Please input your age.",
    alertEnt: "Please enter a valid period",
    alertHeight: "Please enter height",
    alertWeight: "Please enter your weight",
    pagingResult: " search results in total",
    buttonReset: "Reset",
    buttonSubmit: "Search",
    buttonTxt: "Search only for studies that are available for participation",
    search: {
      disease: "Disease classification",
      gender: "Sex",
      age: "Age",
      smoking: "Smoking",
      term: "Period of Application",
      height: "height",
      weight: "weight",
      history: "Medical History",
      select: "Choose one"
    },
    searchRdo: {
      all: "All",
      male: "Male",
      female: "Female",
      smoking: "Smoking",
      nonSmoking: "Non-Smoking",
      input: "Input",
      none: "None",
      yes: "Choose one"
    },
    loding: "loding",
    noResult: "No result"
  },
  recruitView: {
    viewTitle: "Clinical Trial Details",
    buttonMember: "Apply as a Member",
    buttonNonMember: "Apply as a non-member",
    cancerTxt:
      "※ For tumor research, only phone support is available. Contact: ",
    closedTxt: "Finished recruitment notice.",
    title: {
      apply: "How to apply",
      gender: "Sex",
      age: "Age",
      classify: "Study type",
      type: "Types of clinical trials",
      term: "Application period",
      sector: "Volunteer Type",
      smoker: "Smoker",
      smokerY: "Smokers can participate",
      smokerN: "Smoking is prohibited",
      cancer: "Type of cancer",
      disease: "Disease",
      history: "Medical History",
      participation: "Period of participation",
      reward: "Compensation",
      recruitPeriod: "Recruitment period",
      researchPeriod: "Period of study",
      professor: "a professor in charge",
      stage: "phase",
      medicine: "A clinical trial drug",
      patient: "target patient",
      info: "Additional information",
      details: "Details",
      files: "attached file"
    }
  },
  recruitWrite: {
    cancelTxt: "Cancel",
    nextTxt: "Next",
    submitTxt: "Apply",
    cancelMsg: "Are you sure you want to cancel your application?",
    submitMsg: "Would you like to apply for that recruitment?",
    successMsg:
      "Application has been closed.\nIf you are not eligible for recruitment, Please note that you may drop out",
    failMsg: "application failed.",
    alreadyMsg: "You have already applied for this recruitment.",
    recruitTitle: {
      name: "full name",
      mail: "E-mail (ID)",
      phone: "cell phone number",
      contact: "Other Contacts",
      birth: "the date of birth",
      gender: "Sex",
      genderMale: "Male",
      genderFemale: "Female",
      addr: "Address",
      joinPath: "A membership route",
      preferrede: "Preferred contact method",
      rank1: "1st place",
      rank2: "2nd place",
      rank3: "3rd place",
      rank4: "4th place",
      rank5: "5th place",
      nation: "Ethnicities",
      sector: "volunteer type",
      height: "Height",
      weight: "Weight",
      smoking: "Smoking",
      history: "Medical History",
      type: "Types of clinical trials",
      disease: "Type of disease",
      term: "Duration of study application",
      bloodDonation: "Blood donation",
      donationDay: "The recent blood donation day",
      donationType: "Recent blood donation type",
      donationType1: "Ingredient",
      donationType2: "A whole blood",
      bloodTransfusion: "blood transfusion",
      transfusionDay: "the lastest day of blood transfusion",
      joined: "Experinec to apply to clinical trial/bioequivalence test ",
      joinedDay: "The last day of IP administration",
      joined3month:
        "application in clinical trials within 6 months\n application in biological equivalence tests ",
      joined3Day: "Recent application Date",
      drug: "Drug usage status",
      drugName: "Name of drug",
      drugDay: "Date of lastest dosing",
      drugTxt:
        "e.g. medications used within 30 days (e.g., medications prescribed by hospitals, medications taken for a long period of time due to certain diseases requiring treatment, etc.);\n List all general medications (e.g., digestive medicine, cold medicine, artificial tears, eye drops, ointment, pars, etc.)",
      allergy: "Allergic drug and sensitivity",
      allergyType: "kind",
      allergyDay: "Date of initial occurrence",
      allergyTxt:
        "e.g. atopic dermatitis, rhinitis, food allergies, asthma, antibiotics/aspirin/sophilic drugs, overreaction, etc.",
      operation: "Surgery/procedure scheduled ",
      operationType: "Surgery/procedure name",
      operationTxt:
        "e.g. surgery, procedure/attraction scheduled within the clinical trial period",
      surgery: "History of disease/surgery",
      surgeryType: "a disease/procedure name",
      surgeryTxt:
        " e.g. surgery/in-patient treatment, certain diseases that require treatment, skin diseases (dryness, contact dermatitis) or intracutaneous injections may interfere with\nscarring and skin abnormalities or past history of surgery, etc.",
      smokingYn: "Smoking",
      smokingType: "cigarette no./day",
      smokingDay: "The last day of smoking",
      smokingTxt: "(Please record the exact number)",
      nonSmoking: "Non-smokers",
      smoked: "A former smoker",
      smoker: "Current smoker",
      step3Type: "Kind",
      step3Time: "how many times per weeks",
      step3Day: "The last day of intake",
      alcohol: "Drinking status",
      alcoholTime: "A glass/week",
      alcoholDay: "The last drinking day",
      alcoholTxt: "e.g. beer, soju, etc.",
      caffeine: "Caffeine-containing food intake status",
      caffeineTxt:
        "e.g. coffee-containing food, chocolate-containing food, tea (e.g., green tea, black tea, etc.) type, soda (e.g. cola, etc.) and nourishing tonics (e.g., high-caffeine drinks, etc.)",
      etcMedicine: "Chinese medicine/health food intake status",
      etcMedicineTxt:
        "e.g. Chinese medicine taken within 30 days (e.g., red ginseng, etc.) or health function foods (e.g., omega-3 fatty acids, vitamin D, calcium, multivitamin, etc.)",
      diet: "Abnormal dietary intake expected to affect clinical trials ",
      dietTxt:
        "e.g. protein, fatty foods, vegetarian consumption, grapefruit juice, etc.",
      exercise: "Exercise status",
      exerciseDay: "A recent exercise day",
      meal: "Standard meal available",
      mealTxt: "*Standard meals: meals served by hospitals",
      contraception: "Contraceptive availability during clinical trials.",
      precautions: "Willingness to follow precautions",
      precautionsTxt:
        "* Cautions: It depends on study, but during the whole period, drinking, smoking, donating, and transfusion are prohibited. Drinking, caffeine-containing foods and grapefruit-containing foods are prohibited about a week before the date of administration. When visiting the screening, do not eat any food for at least 8 hours, drink plenty of water and please bring your identification card.",
      caution:
        "If your application is eligible for your research, we'll call you to let you know your schedule.\n Even if you visit the hospital after filling out the application form, you cannot apply in the study if it is not eligibile for you, so you could go home. \n Telephone counseling does not mean actual application in the study, and consultation with the clinical workforce after voluntarily visiting the hospital is determined whether or not to apply in the study. All volunteers may be candidates or not be able to apply in the study even if they pass the examination. \n Transportation allwance and case fees are not paid for assessment visits if it is decided you are not eligible tp apply. \n Do you agree with the above and would you like to apply for application?"
    }
  },
  agree: {
    title: "Seoul National University Hospital Clinical Trial",
    agreeTitle: "Agree to the Privacy Policy",
    agreeY: "Agree",
    agreeN: "Disagree",
    btnCancel: "Cancel",
    btnSubmit: "Volunteering for clinical trials",
    agreeMsg: "Please agree to the privacy statement",
    desc: [
      {
        title: "1. Collection and Use of Personal Information",
        cont:
          "서울대학교병원 임상시험센터는「정보통신망 이용촉진 및 정보보호 등에 관한법률」및「개인정보보호법」에 의거하여 개인정보를수집ㆍ이용할 때 동의를 받고 있습니다."
      },
      {
        title: "① Purpose of CollectionㆍUse of Personal Information",
        cont: [
          "ㆍClinical trials volunteer registration",
          "ㆍProvision of various event newsletters issued by the clinical trials center, and information about medical treatment and clinical research"
        ]
      },
      {
        title: "② Duration of PossessionㆍUse of Personal Information",
        cont:
          "We can possess your personal information until we achieve the purpose of collectionㆍuse of information"
      },
      {
        title: "③ Collected items for personal information",
        cont: [
          "ㆍInformation needed for research participation including the name, birth date, gender, nationality, registration channel, email, messenger ID, telephone number, address, preferred contact method and the reason of dropping out",
          "ㆍYour sensitive information collected for the same purposes as above is as follows:",
          "- body data (height, weight)",
          "- body data (height, weight)",
          "ㆍItems recorded in the volunteer field of website, which has been written when volunteering"
        ]
      },
      {
        title: "④ Right to refuse collectionㆍuse of personal information",
        cont:
          "Subjects or their representatives of the study have rights to refuse collection of personal information. However, when rejecting the collection, they may not be able to participate in the clinical trials."
      },
      {
        title: "2. Handling and holding period of personal information",
        cont:
          "The Clinical Trials Center of Seoul National University Hospital handles and holds the personal information within a certain period specified in ‘Duration of CollectionㆍUse of Personal Information’ according to relevant laws or the written content received from information subjects when collecting personal information."
      }
    ]
  },
  contact: {
    title: "Location",
    subTitle: "Questions for Clinical Trials Volunteer Recruitment",
    contactData: [
      {
        id: 0,
        title: "Address",
        cont:
          "4th Fl of Seoul National University Hospital Biomedical Research Institute101 Daehak-ro,Jongno-gu, Seoul 110-744, South Korea"
      },
      {
        id: 1,
        title: "Telephone Number",
        cont: "02-741-4221"
      },
      { id: 2, title: "Via Email", cont: "info@snuh.co.kr" }
    ],
    data: [
      {
        id: 0,
        traffic: "By Bus",
        description: [
          {
            id: 0,
            station:
              "Seoul National Univ. Hospital. ChangKyung Palace bus st.(ChangKyung-Goong)-No.01002",
            way:
              "Blue Bus : 102, 104, 106, 107, 108, 140, 143, 149, 150, 151, 160, 162, 171, 172, 272, 301, 710"
          },
          {
            id: 1,
            station: "Entrance ChangKyung Palace bus st. -No.01224",
            way: "Blue Bus : 151, 171, 172, 272, 601"
          },
          {
            id: 2,
            station: "Hyehwa Station(Metro) Exit3 bus st.-No.01221",
            way:
              "Blue Bus : 102, 104, 106, 107, 108, 109, 143, 149, 150, 160, 162, 273, 301, 601, 710\nGreen Bus : 2112, Jongno 08"
          },
          {
            id: 3,
            station: "Maronie Park (Hyehwa st-Metro)",
            way:
              "Blue Bus : 102, 104, 106, 107, 108, 109, 143, 149, 150, 160, 162, 273, 301, 710\nGreen Bus : 2112, Jongno08, Jongno12(Shuttle Bus to Hospital)"
          }
        ]
      },
      {
        id: 1,
        traffic: "Direction From Train Station/ Airport",
        description: [
          {
            id: 0,
            station: "Seoul Station",
            way: "Seoul Station(Line4) → Hyehwa St. Exit3"
          },
          {
            id: 1,
            station: "Yongsan Station",
            way: "Shin-Yongsan Station(Line4) → Hyehwa St. Exit3"
          },
          {
            id: 2,
            station: "Gimpo International Airport",
            way:
              "Gimpo Int'l Airport Station(Airport Railroad)→Seoul Station(line4)→Hyehwa Station(line4)"
          },
          {
            id: 3,
            station: "Incheon International Airport",
            way:
              "Incheon Int'l Airport Station(Airport Railroad)→Seoul Station(line4)→Hyehwa Station(line4)"
          }
        ]
      },
      {
        id: 2,
        traffic: "Direction from Key High ways/ Express Bus",
        description: [
          {
            id: 0,
            station: "Gangnam Express Terminal",
            way:
              "Express Terminal St.(Line3) → Chungmooro St.(transfer to Line4) → Hyehwa St. Exit3"
          },
          {
            id: 1,
            station: "Nambu Terminal (Seoul Art Center/Line3)",
            way:
              "Nambu Terminal St.(Seoul Art Center/Line3) → Chungmooro St.(transfer to Line4) → Hyehwa St. Exit3 → Hyehwa St. Exit3"
          },
          {
            id: 2,
            station:
              "Dong Seoul Terminal(Eastern Seoul Terminal/Kangbyun St. Line2)",
            way:
              "Gangbyeon Station(line2)→Dongdae History&Culture Park Station(line4) →Hyehwa Station(line4)"
          },
          {
            id: 3,
            station: "Sangbong Terminal(Intercity bus Terminal/Line7)",
            way:
              "Sangbong Terminal(Intercity bus Terminal/Line7) → Kunja St.(transfer to Line5) → Dongdae History&Culture Park Station(line4) → Hyehwa St. Exit3"
          }
        ]
      }
    ],
    other: {
      traffic: "Direction from Highways by Car",
      way:
        "Seoul Tollgate → Hannam Bridge → EulJeero (Street) → Ehwa intersection → Daehakro → Seoul Nat'l Univ. Hospital",
      txt:
        "We provide 4Hour free parking service only for screening participants. (Parking fee will charged if you visit for BMI screening)"
    }
  },
  userInfo: {
    infoTitle: "Member information",
    modifyTitle: "Edit my personal information",
    applyTitle: "Clinical trial application",
    applyModifyTitle: "Edit Clinical trial application",
    joinDate: "Sign up date",
    changePw: "Change Password",
    male: "Male",
    female: "Female",
    participation: "Period of participation",
    alwaysTit: "Open always",
    btnModify: "Modification",
    btnWithdraw: "Withdrawal",
    btnSave: "Save",
    btnCancel: "Cancel",
    failMsg: "Save failed"
  },
  withdrawal: {
    title: "Withdrawal memebaership",
    section1: {
      tit: "Withdrawal Procedure",
      cont: "Please check the instructions before proceeding to withdraw."
    },
    section2: {
      tit: "Instructions for not reusing and recovering email (ID)",
      cont:
        "If you withdrawal memebaership, you will not be able to reuse or recover it.\nPlease be  careful."
    },
    section3: {
      tit:
        "Information on deleting member information and personal service usage records",
      cont:
        "Personal information, clinical trial records and history, and service usage records of your inquiries are all deleted, and deleted data is not restored."
    },
    step2: {
      tit: "Please verify your password to securely unsubscribe.",
      cont:
        "Once your password is verified, your email (ID) will be withdrawn immediately.\n\nIf you withdrawal memebaership, you will not be able to reuse or recover it.\nPlease be  careful."
    },
    form: {
      txt1: "E-mail(ID)",
      txt2: "Password"
    },
    btnCancel: "cancel to unscribe",
    btnStepNext: "Next",
    btnWithdraw: "unscribe"
  },
  recruitHistory: {
    title: "application History"
  }
};
